<nb-card class="reference-import-dialog" style="min-width: 560px; max-width: 700px; max-height: 85vh; overflow-y: auto;">
  <nb-card-header>
    <h4>{{ title }}</h4>
  </nb-card-header>

  <nb-card-body>
    <div class="alert alert-info mb-3" *ngIf="!result">
      <strong>How to import:</strong>
      <ol class="mb-1 mt-1">
        <li>Download the CSV template below</li>
        <li>Fill in the reference rows</li>
        <li>Choose merge or replace mode and upload</li>
      </ol>
      <span *ngIf="kind === 'dsk'"><strong>Merge</strong> updates matching rows; <strong>Replace</strong> clears all DSK groups first.</span>
      <span *ngIf="kind === 'vendor'"><strong>Merge</strong> updates matching vendors; <strong>Replace</strong> clears all vendors first.</span>
    </div>

    <div class="mb-3" *ngIf="!result">
      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="downloadTemplate()">
        <nb-icon icon="download-outline"></nb-icon> Download CSV Template
      </button>
    </div>

    <div class="mb-3" *ngIf="!result">
      <label class="form-label">Import mode</label>
      <select class="form-select" [(ngModel)]="importMode" [disabled]="importing">
        <option value="merge">Merge — update existing, add new</option>
        <option value="replace">Replace — delete all, then import</option>
      </select>
    </div>

    <div class="mb-3" *ngIf="!result">
      <label class="form-label">Select CSV file <span class="text-danger">*</span></label>
      <input type="file" class="form-control" accept=".csv" (change)="onFileSelect($event)" [disabled]="importing">
      <div class="text-danger small mt-1" *ngIf="errorMsg">{{ errorMsg }}</div>
    </div>

    <div class="text-center py-4" *ngIf="importing">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Importing, please wait…</p>
    </div>

    <div *ngIf="result && !importing">
      <div class="row text-center mb-3 g-2">
        <div class="col">
          <div class="stat-box">
            <div class="stat-value text-primary">{{ result.total ?? 0 }}</div>
            <div class="stat-label">Total</div>
          </div>
        </div>
        <div class="col">
          <div class="stat-box">
            <div class="stat-value text-success">{{ result.inserted ?? 0 }}</div>
            <div class="stat-label">Inserted</div>
          </div>
        </div>
        <div class="col">
          <div class="stat-box">
            <div class="stat-value text-info">{{ result.updated ?? 0 }}</div>
            <div class="stat-label">Updated</div>
          </div>
        </div>
        <div class="col">
          <div class="stat-box">
            <div class="stat-value text-secondary">{{ result.skipped ?? 0 }}</div>
            <div class="stat-label">Skipped</div>
          </div>
        </div>
      </div>

      <div class="alert alert-success" *ngIf="!result.errors?.length">
        Import completed with no row errors.
      </div>

      <div *ngIf="result.errors?.length" class="mb-3">
        <div class="alert alert-warning mb-2">
          <strong>{{ result.errors.length }} row(s) had errors.</strong>
        </div>
        <div class="error-list">
          <div class="error-item" *ngFor="let e of result.errors">
            <span class="text-muted">Row {{ e.row }}:</span> {{ e.message }}
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer class="d-flex justify-content-between align-items-center">
    <span class="text-muted small" *ngIf="selectedFile && !result">Selected: {{ selectedFile.name }}</span>
    <span *ngIf="!selectedFile && !result"></span>
    <div class="d-flex gap-2">
      <button class="btn btn-outline-secondary" type="button" (click)="close()" [disabled]="importing">
        {{ result ? 'Close' : 'Cancel' }}
      </button>
      <button class="btn btn-success" type="button" (click)="import()"
        [disabled]="!selectedFile || importing || !!result">
        <span *ngIf="importing" class="spinner-border spinner-border-sm me-1"></span>
        Import
      </button>
    </div>
  </nb-card-footer>
</nb-card>
